module.exports = __webpack_public_path__ + "img/overview4.700d41e7.png";